import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { IncludesSection } from '../components/IncludesSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen font-sans text-gray-900 bg-[#FAF7F2]" data-id="element-231">
      <Hero data-id="element-232" />
      <ProblemSection data-id="element-233" />
      <SolutionSection data-id="element-234" />
      <BenefitsSection data-id="element-235" />
      <IncludesSection data-id="element-236" />
      <CTASection data-id="element-237" />
      <Footer data-id="element-238" />
    </div>;
}